// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader__zBYFV","uploadItem":"uploadItem__2cXn6"};